module.exports = __webpack_public_path__ + "media/images/icon/arrow_small-54027535c9c7bb1993e101d9b6b90865.png";